import React from 'react';
import {
  IconDeviceDesktop,
  IconDeviceGamepad2,
  IconDeviceImac,
  IconDeviceLaptop,
  IconDeviceMobile,
  IconDeviceTablet,
  IconDeviceUnknown,
  IconServer2,
  IconUsb,
  type Icon as TablerIcon,
} from '@tabler/icons-react';
import type { CheckInDeviceType } from '@techgitter/contracts';

/**
 * The one place a check-in device type gets its icon and its picker grouping.
 * Labels come from the contract (`CHECK_IN_DEVICE_TYPE_LABELS`), and a device
 * is named with `checkInDeviceLabel`, which calls an `other` device by what
 * reception said it is ("Drone") rather than "Other".
 *
 * These used to be re-declared in eight components; adding a device type
 * meant finding all eight.
 */
export { CHECK_IN_DEVICE_TYPE_LABELS, checkInDeviceLabel } from '@techgitter/contracts';

export const DEVICE_TYPE_ICON: Record<CheckInDeviceType, TablerIcon> = {
  laptop: IconDeviceLaptop,
  desktop: IconDeviceDesktop,
  all_in_one: IconDeviceImac,
  phone: IconDeviceMobile,
  tablet: IconDeviceTablet,
  hard_drive: IconServer2,
  usb_flash_drive: IconUsb,
  console: IconDeviceGamepad2,
  other: IconDeviceUnknown,
};

export const DeviceTypeIcon: React.FC<{ deviceType: CheckInDeviceType; size?: number }> = ({
  deviceType,
  size = 16,
}) => {
  const Icon = DEVICE_TYPE_ICON[deviceType] ?? IconDeviceUnknown;
  return <Icon size={size} stroke={1.5} />;
};

/** One-tap tiles — about 95% of what comes through the door. */
export const PRIMARY_DEVICE_TYPES: CheckInDeviceType[] = ['laptop', 'desktop', 'all_in_one'];

/** Everything else, behind the picker's "Other device" tile. `other` stays last. */
export const MORE_DEVICE_TYPES: CheckInDeviceType[] = [
  'phone',
  'tablet',
  'hard_drive',
  'usb_flash_drive',
  'console',
  'other',
];
